/**
 * Dimension polarity, mirrored from server/services/indexEngine.js (algorithm v2).
 * Accelerators: a high value pushes toward the race scenario.
 * Brakes: a high value pushes toward slowdown, so a LOW value is the warning sign.
 */

export const ACCELERATORS = ['military_integration', 'centralization', 'economic_dependency'];
export const BRAKES = ['model_governance', 'compute_control', 'international_enforcement', 'public_narrative'];

export const isBrake = (key) => BRAKES.includes(key);

/** 0-3: how much this dimension currently pushes toward the race scenario */
export const racePressure = (key, value) => (isBrake(key) ? 3 - value : value);

/** Risk level from race pressure, shared by cards, radar and log */
export function riskLevel(pressure) {
  if (pressure >= 2.2) return { label: 'HIGH', className: 'text-red', color: 'var(--accent-red)' };
  if (pressure >= 1.5) return { label: 'ELEVATED', className: 'text-yellow', color: 'var(--accent-yellow)' };
  return { label: 'LOW', className: 'text-green', color: 'var(--accent-green)' };
}

/** Trend arrow colored by what the movement means for the race */
export function trendMeaning(key, trend) {
  if (trend === 'stable') return { icon: '■', className: 'text-secondary' };
  const towardRace = (trend === 'increasing') !== isBrake(key);
  return {
    icon: trend === 'increasing' ? '▲' : '▼',
    className: towardRace ? 'text-red' : 'text-green'
  };
}
